import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Clock, LucideAngularModule } from 'lucide-angular';
import { ErrorMessagePipe } from '@app/shared/error-message.pipe';
@Component({
  selector: 'app-time-picker',
  imports: [ReactiveFormsModule, ErrorMessagePipe, LucideAngularModule],
  templateUrl: './time-picker.component.html',
  styleUrl: './time-picker.component.css',
  standalone: true,
})
export class TimePickerComponent implements AfterViewInit, OnInit {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() control: FormControl = new FormControl('', Validators.required);
  @Input() required: boolean = false;
  @Input() helpText: string = '';

  @ViewChild('timePicker') timePicker!: ElementRef;

  protected readonly Object = Object;
  protected readonly Validators = Validators;
  protected readonly Clock = Clock;

  ngOnInit() {
    // if (!this.control.value || this.control.value === '') {
    //   this.control.setValue('08:00:00');
    // }
  }

  ngAfterViewInit() {
    this.timePicker.nativeElement.value = this.control.value;
  }

  changed($event: Event) {
    const inputElement = $event.target as HTMLInputElement;
    // if value doesn't have seconds, add them
    if (inputElement.value.length === 5) {
      inputElement.value += ':00';
    }
    this.control.setValue(inputElement.value);
    this.control.markAsDirty();
  }
}
